import { Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { createEditorReducer } from '../../editor/reducer';
import migrateDolan from '../dolan/utils/migrateDolan';
import postProcessDolan from '../dolan/utils/postProcessDolan';

export default createEditorReducer<Dolan>({
  /**
   * These "migrations" are done immediately when the descriptor is loaded, before the user starts editing it.
   * It should be used to ENSURE THAT APP EDITOR WORKS WITH THE DESCRIPTOR. Therefore you should _avoid_
   * making unnecessary changes as they would show the "Save" button even before user makes any actual changes.
   */
  migrateDescriptor: migrateDolan,
  /**
   * These changes are done after every single edit of the descriptor. It should be used for e.g. cleanups.
   * The logic here *must* be fast enough even for big descriptors, as it's run after every single edit.
   */
  postProcessDescriptor: postProcessDolan,
});
